import { User } from "@m7-health/shared-utils";

import { TCurrentUser } from "../store/types";

import { useCurrentUser } from "./useUser";

/**
 * If an admin is acting as another user, returns the acting admin.
 * Else if no one is acting as another user, or acting user doesn't have admin role, returns null.
 */
export const useAdminActingAs = (): TCurrentUser["actingAdmin"] | null => {
  const currentUser = useCurrentUser();
  const actingAdmin = currentUser.actingAdmin;
  return actingAdmin?.roles.includes(User.ERole.admin) ? actingAdmin : null;
};
